import React, { Component } from 'react'
import { Card, Button } from 'react-bootstrap'
import ConsultaChoferInfo from './ConsultaChoferInfo'
import { IconButton } from '@material-ui/core'
import { connect } from 'react-redux'
import * as actions from '../../actions'
import StepperBar from './StepperBar'
import moment from 'moment'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Alert from '@material-ui/lab/Alert'
import PedidosVigentesConsulta from './PedidosVigentesConsulta'
import InstanciaPlaya from './instanciasCPA/InstanciaPlaya'
import InstanciaCalado from './instanciasCPA/InstanciaCalado'
import InstanciaDescarga from './instanciasCPA/InstanciaDescarga'
import ReceiptIcon from '@material-ui/icons/Receipt'
import { PDFDownloadLink } from '@react-pdf/renderer'
import GenerarDescargaPdf from '../../../Forms/SharedComponents/containers/GenerarDescargaPdf/GenerarDescargaPdf'
import _ from 'lodash'
import { saveAs } from 'file-saver'

class ConsultaConIngreso extends Component {
  constructor (props) {
    super(props)
    this.handleOpen = this.handleOpen.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.descargarDetalle = this.descargarDetalle.bind(this)
    this.savePdf = this.savePdf.bind(this)
    this.state = { nombreInstancia: '' }
    this.state = { instancia: 0 }
  }

  componentDidMount () {
    const { cpa, getTurnosPendientes, getTotalCamiones, getCamionesPedidos, getCortes } = this.props
    getTurnosPendientes(cpa.turnoDeSalida, cpa.claveCereal.trimEnd())
    getTotalCamiones()
    getCamionesPedidos()
    getCortes()

    let textVolcadora
    if (cpa && cpa.volcadoraCamiones) {
      if (cpa.volcadoraCamiones === 'PV1     ') {
        textVolcadora = 'Descargado en volcadora 1'
      } else if (cpa.volcadoraCamiones === 'PV2     ') {
        textVolcadora = 'Descargado en volcadora 2'
      } else if (cpa.volcadoraCamiones === 'PV4     ') {
        textVolcadora = 'Descargado en volcadora 4'
      } else if (cpa.volcadoraCamiones === 'PV5     ') {
        textVolcadora = 'Descargado en volcadora 5'
      }
    }

    let enPlayaCalado
    if (cpa.calleDeCalado) {
      enPlayaCalado = `En espera en la fila ${cpa.calleDeCalado} de la playa de calado`
    }

    if (cpa.estadoCarga === 'descargada' || cpa.estadoCtg === 'D' || cpa.fechaDeDestare) {
      this.setState({ instancia: 4 })
      this.setState({ nombreInstancia: textVolcadora })
    } else if (cpa.fechaDeEgresoCalado) {
      this.setState({ instancia: 3 })
      this.setState({ nombreInstancia: 'Proximo a descarga' })
    } else if (cpa.estadoCarga === 'calada' || cpa.fechaDeCalado) {
      this.setState({ instancia: 2 })
      this.setState({ nombreInstancia: enPlayaCalado })
    } else if (cpa.fechaDeEgresoPlaya) {
      this.setState({ nombreInstancia: 'Proximo a calado' })
      this.setState({ instancia: 1 })
    } else if (!cpa.fechaDeEgresoPlaya) {
      this.setState({ instancia: 0 })
      this.setState({ nombreInstancia: 'Se encuentra en la Playa Municipal' })
    }
  }

  handleOpen () {
    this.props.updateShowInfoVolcadoras(true)
  }

  handleClose () {
    this.props.updateShowInfoVolcadoras(false)
  }

  async descargarDetalle (numero) {
    const { obtenerDetalleMercaderia, descargarDetallesPDF } = this.props
    const detalle = await obtenerDetalleMercaderia(numero)
    if (detalle !== null) {
      descargarDetallesPDF()
    }
  }

  savePdf (url, filename) {
    this.props.saveDetalle()
    saveAs(url, filename)
  }

  render () {
    const {
      cpa,
      fechaCupo,
      cerealVolcadoras,
      turnosPendientes,
      totalCamiones,
      handleReset,
      pedidoCamiones,
      cortesPedidos
    } = this.props

    const numero = cpa.numero
    const camion = cpa.camion
    const acoplado = cpa.acoplado
    const cereal = cpa.claveCereal

    const turno = cpa.turnoDeSalida

    const cpaDatos = {
      numero,
      camion,
      acoplado,
      cereal,
      fechaCupo,
      turno
    }

    // var ultimaDescarga

    // const turnosPorCereal = cerealVolcadoras.filter(volcadora => volcadora.cereal === cpa.claveCereal)
    // if (turnosPorCereal.length > 0) {
    //   const turnosOrdenados = turnosPorCereal.sort((a, b) => b.turnoDeSalida - a.turnoDeSalida)
    //   ultimaDescarga = turnosOrdenados[0].turnoDeSalida
    // } else {
    //   ultimaDescarga = 0
    // }

    const descargaCereal = cerealVolcadoras.filter(volcadora => volcadora.cereal === cpa.claveCereal && volcadora.estadoVolcadora === 'Activa')
    const descargaActiva = descargaCereal.length > 0

    const fEgresoPlaya = moment.unix(cpa.fechaDeEgresoPlaya).format('DD/MM/YYYY hh:mm a')
    const cpaConError = (cpa.estadoCtg !== 'V' && cpa.estadoCtg !== 'D') || (cpa.turnoDeSalida === null)

    let estadoCTG
    // let mensajeAdicional
    if (cpa.turnoDeSalida) {
      if (cpa.estadoCtg === 'V') {
        estadoCTG = 'Validada'
      } else if (cpa.estadoCtg === 'D') {
        estadoCTG = 'Descargada'
      } else {
        estadoCTG = 'Aun no se encuentra validada, no podrá egresar. Puede comunicarse con el entregador'
      }
    } else {
      estadoCTG = 'No tiene asignado un turno de salida, debe normalizar su cupo.'
      // if (cpa.fechaCupo) {
      //   // let fCupo = moment(cpa.fechaCupo).format('DD/MM/YYYY')
      //   console.log(cpa.fechaCupo)
      //   const now = moment().format('DD/MM/YYYY')
      //   console.log('ahora es: ', now)
      //   // console.log(now.isAfter(fCupo))
      // }
    }

    let rechazoCTG
    if (cpa) {
      if (cpa.estadoCalificacion === 'R') {
        rechazoCTG = 'Carta de porte rechazada en calado'
      } else if (cpa.rechazoAdministrativoCalado === 'R') {
        rechazoCTG = 'Carta de porte rechazada administrativamente en calado'
      } else if (cpa.rechazoAdministrativoCalado === 'P') {
        rechazoCTG = 'Carta de porte pendiente de autorización en calado'
      } else if (cpa.fechaDeRechazoEnPesado) {
        rechazoCTG = 'Carta de porte rechazada en pesado'
      }
    }

    const pedidos = _(pedidoCamiones)
      .groupBy('cereal')
      .map(function (pedido, cereal, restantes) {
        return {
          cereal: (cereal),
          restantes: _.sum(pedido.map((p) => p.restantes))
        }
      }).value()

    let corteProducto
    if (cortesPedidos.length > 0) {
      corteProducto = cortesPedidos.filter(corte => corte.cereal.trim() === cereal.trim() && corte.vigente)
    }

    return (
      <div>

        <div className='titulo-en-cabecera'>
          <IconButton onClick={handleReset}><ArrowBackIcon /></IconButton>
          <h5>Estado de carta de porte</h5>
        </div>

        <Card style={{ margin: '2%' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: 'white' }}>
            <Card.Title style={{ margin: 'auto' }}> {this.state.nombreInstancia}</Card.Title>
          </Card.Header>
        </Card>

        <ConsultaChoferInfo cpaDatos={cpaDatos} />

        {/* ALERTAS */}
        { rechazoCTG && <div style={{ margin: '5% 2%' }}>
          <Alert className='alert-consulta-chofer' variant='filled' severity='error'>{rechazoCTG}</Alert>
        </div>
        }

        { !rechazoCTG && <div>
          {/* Alertas y notificaciones */}
          { !cpa.fechaDeEgresoPlaya && !cpa.fechaDeCalado && <div style={{ margin: '0 2% 2% 2%' }}>
            <Alert className='alert-consulta-chofer' variant='filled' severity='warning'>
              <strong style={{ fontSize: '1.05rem' }} >Sr. transportista por favor verifique sus datos para evitar demoras.</strong>
            </Alert>
          </div>
          }

          {!cpa.fechaDeEgresoPlaya && !cpa.fechaDeCalado && corteProducto && corteProducto[0].activo && <div style={{ margin: '0 2% 2% 2%' }}>
            <Alert className='alert-consulta-chofer' variant='filled' severity='error'>Este producto ya no será descargado hoy </Alert>
          </div>
          }

          { this.state.instancia === 4 && <div>
            { !cpaConError && <div style={{ margin: '0 2% 2% 2%' }}>
              <Alert className='alert-consulta-chofer' variant='filled' severity='success'>
              Estado de CTG en ARCA: <strong style={{ fontSize: '1.05rem' }} >{estadoCTG}</strong>
              </Alert>
            </div>
            }
          </div>
          }
          { !cpa.fechaDeEgresoPlaya && <div>
            { !cpaConError && <div style={{ margin: '0 2% 2% 2%' }}>
              <Alert className='alert-consulta-chofer' variant='filled' severity='success'>
              Estado de CTG en ARCA: <strong style={{ fontSize: '1.05rem' }} >{estadoCTG}</strong>
              </Alert>
            </div>
            }
            { cpaConError && <div style={{ margin: '0 2% 2% 2%' }}>
              <Alert className='alert-consulta-chofer' variant='filled' severity='error'>{estadoCTG}</Alert>
            </div>
            }
          </div>
          }
          { cpa.rechazoAdministrativoCalado && <div style={{ margin: '0 2% 2% 2%' }}>
            <Alert className='alert-consulta-chofer' variant='filled' severity='error'>Su mercadería se encuentra pendiente de autorizar</Alert>
          </div>
          }

          {/* INFO POR INSTANCIAS */}
          <div className='container-consulta-chofer'>
            <Card className='card-info-instancia-circuito'>
              <Card.Body className='card-body-info-instancia'>

                {/* EN PLAYA */}
                {!cpa.fechaDeEgresoPlaya && <div>
                  <InstanciaPlaya cpa={cpa} turnosPendientes={turnosPendientes} totalCamiones={totalCamiones} cerealVolcadoras={cerealVolcadoras} />
                </div>}

                {/* ENTRE PLAYA Y CALADO */}
                {!cpa.fechaDeEgresoCalado && cpa.fechaDeEgresoPlaya && <div>
                  {(!cpa.fechaDeCalado) && <div>
                    <div className='fechas-instancias'>
                      <h6 className='texto-info'>Egreso de la playa de camiones:<br />{fEgresoPlaya}</h6>
                    </div>
                    <div className='cantidad-camiones-circuito'>
                      <h6 className='texto-info'>Listo para el proceso de calado</h6>
                    </div>
                  </div>
                  }

                  {/* CALADO */}
                  {cpa.fechaDeCalado && (cpa.estadoCalificacion !== 'R') && <div>
                    <InstanciaCalado cpa={cpa} />
                  </div>}
                </div>}

                {/* DESCARGA */}
                {cpa.fechaDeDestare && <div>
                  <InstanciaDescarga cpa={cpa} />
                </div>}
              </Card.Body>
            </Card>
            {/* {this.state.instancia !== 4 && <div className='card-info-volcadoras-desktop'>
                <VolcadorasInfoEstado cpa={cpa} />
             </div>} */}
          </div>
          {!cpa.fechaDeEgresoPlaya && <PedidosVigentesConsulta cpa={cpa} pedidos={pedidos} /> }

          {this.state.instancia < 4 && <div>
            <div style={{ margin: '5% 0 25vh 0' }} >
              {/* {ultimaDescarga !== 0 && <h6 className='texto-info'>Último turno descargado de {cpa.cereal}: {ultimaDescarga}</h6>} */}
              {this.state.instancia === 2 && <div>
                {descargaActiva && <h6 className='texto-info'>La descarga de {cpa.cereal} se encuentra <strong>en curso</strong></h6>}
              </div> }
            </div>
            {/* <div className='btn-estado-volcadoras'>
            <Button size='lg' onClick={this.handleOpen}>Ver estado de volcadoras</Button>
          </div>
          <Dialog
            open={show}
            onClose={this.handleClose}
            fullWidth
            maxWidth='xl'
          >
            <VolcadorasInfoEstado cpa={cpa} />
            <div style={{ margin: '2% auto' }}>
              <Button size='lg' onClick={this.handleClose}>Cerrar</Button>
            </div>
          </Dialog> */}
          </div>}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', margin: '0 0 20vh 0' }}>

            {this.state.instancia === 4 && <Button variant='primary' size='lg' onClick={() => this.descargarDetalle(cpa.numero)} className='btn-ticket-descarga-consulta'>
              <h6 className='texto-info'>Ticket de descarga</h6>
              <ReceiptIcon style={{ marginBottom: '5' }} size='large' variant='light' />
            </Button> }

          </div>
          <div className='hidden'>
            {this.props.fileDetallePdfOk && this.props.detalleLiqMercaderia.cartaDePorteAutomotor && (
              <PDFDownloadLink
                document={
                  <GenerarDescargaPdf
                    data={this.props.detalleLiqMercaderia}
                    info={{
                      version: `${this.props.versionLaridae}`,
                      acta: `${this.props.acta}`
                    }}
                  />
                }
                fileName={`Certificado de Descarga CTG ${this.props.detalleLiqMercaderia.cartaDePorteAutomotor}.pdf`}
                style={{
                  textDecoration: 'none',
                  padding: '8px 16px',
                  marginLeft: '20px',
                  color: '#FFFFFF',
                  fontSize: '20px',
                  height: '60px',
                  fontFamily: 'sans-serif',
                  backgroundColor: '#007BFF',
                  borderRadius: '5px 5px 5px 5px'
                }}
              >
                {({ blob, url, loading, error }) => (
                  !loading
                    ? this.savePdf(url, `Certificado de Descarga CTG ${this.props.detalleLiqMercaderia.cartaDePorteAutomotor}.pdf`)
                    : 'Generando PDF...'
                )}
              </PDFDownloadLink>
            )}
          </div>
          {/* PROGRESS BAR INSTANCIAS  */}
          <div className='estado-progreso-chofer'>
            <div className='container-progress-bar'>
              <StepperBar instancia={this.state.instancia} />
            </div>
          </div>
        </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  cerealVolcadoras: state.volcadora.cerealVolcadoras,
  cortesPedidos: state.camionesIngreso.cortesPedidos,
  detalle: state.entregadores.detalle,
  detalleLiqMercaderia: state.entregadores.detalleLiqMercaderia,
  show: state.camionesIngreso.showInfoVolcadoras,
  totalCamiones: state.camionesIngreso.totalCamionesCereal,
  turnosPendientes: state.camionesIngreso.turnosPendientesPlaya,
  pedidoCamiones: state.camionesIngreso.camionesPedidos,
  acta: state.entregadores.acta,
  fileDetallePdfOk: state.entregadores.fileDetallePdfOk,
  versionLaridae: state.utils.versionLaridae
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(ConsultaConIngreso)
